import { ArrowForwardRounded } from '@mui/icons-material';
import CustomDropdown from '../reusable/dropdown';
import { settingProspectsManualMapping } from '../../redux/slices/prospect';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const MapperOneComponent = ({ destinationRootHeader, selectedIndex }: { destinationRootHeader: Record<string, string>[], selectedIndex: number }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { manual, loaders } = useSelector((state: RootState) => state.prospect);

    const handleChange = (header: string, value: string) => {
        const updatedMapping = {
            ...manual.mapping,
            [header]: value
        };
        dispatch(settingProspectsManualMapping(updatedMapping));
    };

    return <Box mt={4} px={2}>
        <Grid container spacing={1} sx={{ fontWeight: 'bold', mb: 1, border: '1px solid lightgray', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
            <Grid item xs={4}><Typography variant="subtitle1" color="textSecondary" fontWeight="bold">DESTINATION HEADER</Typography></Grid>
            <Grid item xs={4}><Typography variant="subtitle1" color="textSecondary" fontWeight="bold">IMPORTED HEADER</Typography></Grid>
            <Grid item xs={4}><Typography variant="subtitle1" color="textSecondary" fontWeight="bold">PREVIEW</Typography></Grid>
        </Grid>

        {destinationRootHeader.map((header, idx) => (
            <Grid container spacing={1} key={idx} alignItems="center" mb={1} pb={1} sx={{
                borderLeft: '1px solid lightgray',
                borderRight: '1px solid lightgray',
                borderBottom: '1px solid lightgray',
                borderBottomLeftRadius: idx + 1 === destinationRootHeader.length ? '10px' : '0',
                borderBottomRightRadius: idx + 1 === destinationRootHeader.length ? '10px' : '0'
            }}>
                <Grid item xs={4}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="subtitle1" color="textDisabled">{header.value}</Typography>
                        <ArrowForwardRounded />
                    </Box>
                </Grid>
                <Grid item xs={4}>
                    <CustomDropdown
                        options={manual?.csvHeaders?.map((field) => ({
                            label: field,
                            value: field
                        }))}
                        value={manual.mapping[header.value] || ''}
                        onChange={(e) => handleChange(header.value, e.target.value as string)}
                        disabled={loaders.isCreating}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 200,
                                    overflowY: 'auto'
                                }
                            }
                        }}
                        sx={{
                            mb: 0
                        }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2" color="textSecondary">
                        {manual?.rows?.[selectedIndex - 1]?.[manual.mapping[header.value]] || '-'}
                    </Typography>
                </Grid>
            </Grid>
        ))}
    </Box>;
};


export default MapperOneComponent;